module.exports = __webpack_public_path__ + "static/media/afforday.d53af07b.jpg";